import React, { useContext, useMemo } from 'react';
import { jsx } from 'react/jsx-runtime';
import PropTypes from 'prop-types';

/* eslint-disable class-methods-use-this */

class Tracking {
  constructor() {
    let opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    this.options = {
      dataLayer: typeof window !== 'undefined' ? window.dataLayer || null : null,
      ...opts
    };
  }
  push() {
    const {
      dataLayer
    } = this.options;
    if (dataLayer === null) {
      return;
    }
    dataLayer.push(...arguments);
  }
  trackEvent(category, action) {
    let label = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    let value = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    this.push({
      event: 'eventInteraction',
      eventCategory: category,
      eventAction: action,
      eventLabel: label,
      eventValue: value
    });
  }
  trackSocial(network, action) {
    let target = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    this.push({
      event: 'socialInteraction',
      socialNetwork: network,
      socialAction: action,
      socialTarget: target || this.getSocialTarget()
    });
  }
  getSocialTarget() {
    return typeof window !== 'undefined' ? `${window.location.protocol}//${window.location.host}` : null;
  }
}
var Tracking$1 = Tracking;

const TrackingContext = /*#__PURE__*/React.createContext();
var TrackingContext$1 = TrackingContext;

const getDisplayName = WrappedComponent => WrappedComponent.displayName || WrappedComponent.name || 'Component';
const withTracking = WrappedComponent => {
  const WithTrackingComponent = props => /*#__PURE__*/jsx(TrackingContext$1.Consumer, {
    children: tracking => /*#__PURE__*/jsx(WrappedComponent, {
      tracking: tracking,
      ...props
    })
  });
  WithTrackingComponent.displayName = `WithTracking(${getDisplayName(WrappedComponent)})`;
  return WithTrackingComponent;
};
var withTracking$1 = withTracking;

const useTracking = () => useContext(TrackingContext$1);
var useTracking$1 = useTracking;

const propTypes = {
  tracking: PropTypes.instanceOf(Tracking$1),
  children: PropTypes.node
};
const defaultProps = {
  tracking: null,
  children: null
};
const TrackingContainer = _ref => {
  let {
    children,
    tracking
  } = _ref;
  const finalTracking = useMemo(() => tracking || new Tracking$1(), [tracking]);
  return /*#__PURE__*/jsx(TrackingContext$1.Provider, {
    value: finalTracking,
    children: children
  });
};
TrackingContainer.propTypes = propTypes;
TrackingContainer.defaultProps = defaultProps;
var TrackingContainer$1 = TrackingContainer;

export { Tracking$1 as Tracking, TrackingContainer$1 as TrackingContainer, TrackingContext$1 as TrackingContext, Tracking$1 as default, useTracking$1 as useTracking, withTracking$1 as withTracking };
